// Single scroll-positioning primitive for hash + ?focus= arrivals.
// Waits for the target to render, jumps once (no animated travel from the
// top), then holds it under the fixed navbar while async content/images
// settle above it. Any user scroll intent releases the hold immediately.
const USER_INTENT = ["wheel", "touchstart", "keydown"];

export const scrollToTarget = (findTarget, { offset, timeout = 4000, settleMs = 1500, onFound } = {}) => {
  let done = false;
  let el = null;
  let mo = null;
  let ro = null;
  let giveUp = 0;
  let settle = 0;

  const position = () => {
    const margin = offset ?? (parseFloat(getComputedStyle(el).scrollMarginTop) || 96);
    const top = Math.max(0, el.getBoundingClientRect().top + window.scrollY - margin);
    if (Math.abs(window.scrollY - top) > 1) window.scrollTo({ top, behavior: "instant" });
  };

  const stop = () => {
    if (done) return;
    done = true;
    if (mo) mo.disconnect();
    if (ro) ro.disconnect();
    window.clearTimeout(giveUp);
    window.clearTimeout(settle);
    USER_INTENT.forEach((ev) => window.removeEventListener(ev, stop));
  };

  const tryFind = () => {
    if (done || el) return;
    el = findTarget();
    if (!el) return;
    if (mo) mo.disconnect();
    window.clearTimeout(giveUp);
    position();
    if (onFound) onFound(el);
    if (typeof ResizeObserver !== "undefined") {
      ro = new ResizeObserver(() => { if (!done) position(); });
      ro.observe(document.body);
    }
    settle = window.setTimeout(stop, settleMs);
  };

  USER_INTENT.forEach((ev) => window.addEventListener(ev, stop, { passive: true }));
  mo = new MutationObserver(tryFind);
  mo.observe(document.body, { childList: true, subtree: true });
  giveUp = window.setTimeout(stop, timeout);
  requestAnimationFrame(tryFind);
  return stop;
};

export const hashTarget = (hash) => () => {
  if (!hash || hash.length < 2) return null;
  try {
    return document.getElementById(decodeURIComponent(hash.slice(1)));
  } catch {
    return null;
  }
};
